import * as objectTypes from "../constants/objectTypes";
import * as propertyConstants from "../constants/propertyConstants";
import * as tableConstants from "../constants/tableConstants";
import * as tableHelper from "../helpers/tableHelper";
import * as translationHelper from "../helpers/translationHelper";

import { TableHeading } from "./tableHeading";

export class Base {
    id: number;
    name: string;
    nameMaster: string | null;
    nameSystem: string | null;
    parentId?: number | null;
    nameSource?: number;
    searchName?: string | null;
    searchNameMaster?: string | null;
    searchNameSystem?: string | null;
    searchNameSource?: number;
    printName?: string | null;
    printNameMaster?: string | null;
    printNameSystem?: string | null;
    printNameSource?: number;
    tmcName?: string;
    tmcNameMaster?: string | null;
    tmcNameSystem?: string | null;
    tmcNameSource?: number;
    code?: string;
    codeMaster?: string | null;
    codeSystem?: string | null;
    codeSource?: number;
    searchCode?: string | null;
    searchCodeMaster?: string | null;
    searchCodeSystem?: string | null;
    searchCodeSource?: number;
    priority?: number | null;
    priorityMaster?: number | null;
    prioritySystem?: number | null;
    prioritySource?: number;
    moreInfo?: string | null;
    moreInfoMaster?: string | null;
    moreInfoSystem?: string | null;
    moreInfoSource?: number;
    uuid?: string | null;

    constructor(
        id: number,
        name: string,
        nameMaster: string | null,
        nameSystem: string | null,
        parentId?: number | null,
        nameSource?: number,
        searchName?: string | null,
        searchNameMaster?: string | null,
        searchNameSystem?: string | null,
        searchNameSource?: number,
        printName?: string | null,
        printNameMaster?: string | null,
        printNameSystem?: string | null,
        printNameSource?: number,
        tmcName?: string,
        tmcNameMaster?: string | null,
        tmcNameSystem?: string | null,
        tmcNameSource?: number,
        code?: string,
        codeMaster?: string | null,
        codeSystem?: string | null,
        codeSource?: number,
        searchCode?: string | null,
        searchCodeMaster?: string | null,
        searchCodeSystem?: string | null,
        searchCodeSource?: number,
        priority?: number | null,
        priorityMaster?: number | null,
        prioritySystem?: number | null,
        prioritySource?: number,
        moreInfo?: string | null,
        moreInfoMaster?: string | null,
        moreInfoSystem?: string | null,
        moreInfoSource?: number,
        uuid?: string | null
    ) {
        this.id = id;
        this.name = name;
        this.nameMaster = nameMaster;
        this.nameSystem = nameSystem;
        this.parentId = parentId;
        this.nameSource = nameSource;
        this.searchName = searchName;
        this.searchNameMaster = searchNameMaster;
        this.searchNameSystem = searchNameSystem;
        this.searchNameSource = searchNameSource;
        this.printName = printName;
        this.printNameMaster = printNameMaster;
        this.printNameSystem = printNameSystem;
        this.printNameSource = printNameSource;
        this.tmcName = tmcName;
        this.tmcNameMaster = tmcNameMaster;
        this.tmcNameSystem = tmcNameSystem;
        this.tmcNameSource = tmcNameSource;
        this.code = code;
        this.codeMaster = codeMaster;
        this.codeSystem = codeSystem;
        this.codeSource = codeSource;
        this.searchCode = searchCode;
        this.searchCodeMaster = searchCodeMaster;
        this.searchCodeSystem = searchCodeSystem;
        this.searchCodeSource = searchCodeSource;
        this.priority = priority;
        this.priorityMaster = priorityMaster;
        this.prioritySystem = prioritySystem;
        this.prioritySource = prioritySource;
        this.moreInfo = moreInfo;
        this.moreInfoMaster = moreInfoMaster;
        this.moreInfoSystem = moreInfoSystem;
        this.moreInfoSource = moreInfoSource;
        this.uuid = uuid;
    }
}

export function mapBase(data: Record<string, any>): Base | null {
    try {
        return new Base(
            data.id,
            data.name,
            data.nameMaster,
            data.nameSystem,
            data.parentId,
            data.nameSource,
            data.searchName,
            data.searchNameMaster,
            data.searchNameSystem,
            data.searchNameSource,
            data.printName,
            data.printNameMaster,
            data.printNameSystem,
            data.printNameSource,
            data.tmcName,
            data.tmcNameMaster,
            data.tmcNameSystem,
            data.tmcNameSource,
            data.code,
            data.codeMaster,
            data.codeSystem,
            data.codeSource,
            data.searchCode,
            data.searchCodeMaster,
            data.searchCodeSystem,
            data.searchCodeSource,
            data.priority,
            data.priorityMaster,
            data.prioritySystem,
            data.prioritySource,
            data.moreInfo,
            data.moreInfoMaster,
            data.moreInfoSystem,
            data.moreInfoSource,
            data.uuid
        );
    } catch (e) {
        return null;
    }
}

export function updateBase(oldBase: Base | null, updatedData: Record<string, any>): Base | null {
    try {
        if (oldBase === null) {
            return null;
        }

        return new Base(
            oldBase.id,
            updatedData.name ? updatedData.name : oldBase.name,
            oldBase.nameMaster,
            oldBase.nameSystem,
            oldBase.parentId,
            oldBase.nameSource,
            updatedData.searchName ? updatedData.searchName : oldBase.searchName,
            oldBase.searchNameMaster,
            oldBase.searchNameSystem,
            oldBase.searchNameSource,
            updatedData.printName ? updatedData.printName : oldBase.printName,
            oldBase.printNameMaster,
            oldBase.printNameSystem,
            oldBase.printNameSource,
            updatedData.tmcName ? updatedData.tmcName : oldBase.tmcName,
            oldBase.tmcNameMaster,
            oldBase.tmcNameSystem,
            oldBase.tmcNameSource,
            updatedData.code ? updatedData.code : oldBase.code,
            oldBase.codeMaster,
            oldBase.codeSystem,
            oldBase.codeSource,
            updatedData.searchCode ? updatedData.searchCode : oldBase.searchCode,
            oldBase.searchCodeMaster,
            oldBase.searchCodeSystem,
            oldBase.searchCodeSource,
            updatedData.priority ? updatedData.priority : oldBase.priority,
            oldBase.priorityMaster,
            oldBase.prioritySystem,
            oldBase.prioritySource,
            updatedData.moreInfo ? updatedData.moreInfo : oldBase.moreInfo,
            oldBase.moreInfoMaster,
            oldBase.moreInfoSystem,
            oldBase.moreInfoSource,
            updatedData.uuid ? updatedData.uuid : oldBase.uuid
        );
    } catch (e) {
        return null;
    }
}

export function createEmptyBase(): any {
    return {
        [propertyConstants.PROPERTY_ID]: "",
        [propertyConstants.PROPERTY_NAME]: "",
        [propertyConstants.PROPERTY_SEARCH_NAME]: "",
        [propertyConstants.PROPERTY_PRINT_NAME]: "",
        [propertyConstants.PROPERTY_TMC_NAME]: "",
        [propertyConstants.PROPERTY_CODE]: "",
        [propertyConstants.PROPERTY_SEARCH_CODE]: "",
        [propertyConstants.PROPERTY_PRIORITY]: "",
        [propertyConstants.PROPERTY_MORE_INFO]: "",
        [propertyConstants.PROPERTY_UUID]: ""
    };
}

export function generateBaseData(list: Array<Base>): Array<any> {
    const data: Array<any> = [];
    let item: Base;

    for (item of list) {
        data.push({
            [propertyConstants.PROPERTY_ID]: item.id,
            [propertyConstants.PROPERTY_NAME]: item.name,
            [propertyConstants.PROPERTY_NAME_MASTER]: item.nameMaster,
            [propertyConstants.PROPERTY_NAME_SYSTEM]: item.nameSystem,
            [propertyConstants.PROPERTY_PARENT_ID]: item.parentId,
            [propertyConstants.PROPERTY_NAME_SOURCE]: item.nameSource,
            [propertyConstants.PROPERTY_SEARCH_NAME]: item.searchName,
            [propertyConstants.PROPERTY_SEARCH_NAME_MASTER]: item.searchNameMaster,
            [propertyConstants.PROPERTY_SEARCH_NAME_SYSTEM]: item.searchNameSystem,
            [propertyConstants.PROPERTY_SEARCH_NAME_SOURCE]: item.searchNameSource,
            [propertyConstants.PROPERTY_PRINT_NAME]: item.printName,
            [propertyConstants.PROPERTY_PRINT_NAME_MASTER]: item.printNameMaster,
            [propertyConstants.PROPERTY_PRINT_NAME_SYSTEM]: item.printNameSystem,
            [propertyConstants.PROPERTY_PRINT_NAME_SOURCE]: item.printNameSource,
            [propertyConstants.PROPERTY_TMC_NAME]: item.tmcName,
            [propertyConstants.PROPERTY_TMC_NAME_MASTER]: item.tmcNameMaster,
            [propertyConstants.PROPERTY_TMC_NAME_SYSTEM]: item.tmcNameSystem,
            [propertyConstants.PROPERTY_TMC_NAME_SOURCE]: item.tmcNameSource,
            [propertyConstants.PROPERTY_CODE]: item.code,
            [propertyConstants.PROPERTY_CODE_MASTER]: item.codeMaster,
            [propertyConstants.PROPERTY_CODE_SYSTEM]: item.codeSystem,
            [propertyConstants.PROPERTY_CODE_SOURCE]: item.codeSource,
            [propertyConstants.PROPERTY_SEARCH_CODE]: item.searchCode,
            [propertyConstants.PROPERTY_SEARCH_CODE_MASTER]: item.searchCodeMaster,
            [propertyConstants.PROPERTY_SEARCH_CODE_SYSTEM]: item.searchCodeSystem,
            [propertyConstants.PROPERTY_SEARCH_CODE_SOURCE]: item.searchCodeSource,
            [propertyConstants.PROPERTY_PRIORITY]: item.priority,
            [propertyConstants.PROPERTY_PRIORITY_MASTER]: item.priorityMaster,
            [propertyConstants.PROPERTY_PRIORITY_SYSTEM]: item.prioritySystem,
            [propertyConstants.PROPERTY_PRIORITY_SOURCE]: item.prioritySource,
            [propertyConstants.PROPERTY_MORE_INFO]: item.moreInfo,
            [propertyConstants.PROPERTY_MORE_INFO_MASTER]: item.moreInfoMaster,
            [propertyConstants.PROPERTY_MORE_INFO_SYSTEM]: item.moreInfoSystem,
            [propertyConstants.PROPERTY_MORE_INFO_SOURCE]: item.moreInfoSource,
            [propertyConstants.PROPERTY_UUID]: item.uuid
        });
    }

    return data;
}

export function generateBaseHeadings(
    objectType: objectTypes.ObjectType,
    orderList: Array<propertyConstants.Property>,
    visibleList: Array<propertyConstants.Property>,
    editableList: Array<propertyConstants.Property>,
    requiredList: Array<propertyConstants.Property>,
    alwaysVisibleList: Array<propertyConstants.Property>,
    widthOption: Record<propertyConstants.Property, number>
): Array<TableHeading> {
    const list = [
        new TableHeading(
            propertyConstants.PROPERTY_CODE,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_CODE),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_CODE),
            editableList.includes(propertyConstants.PROPERTY_CODE),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_CODE),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_CODE),
            requiredList.includes(propertyConstants.PROPERTY_CODE),
            [],
            widthOption?.[propertyConstants.PROPERTY_CODE] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_ID,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_ID),
            tableConstants.TABLE_TYPE_NUMBER,
            visibleList.includes(propertyConstants.PROPERTY_ID),
            editableList.includes(propertyConstants.PROPERTY_ID),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_ID),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_ID),
            requiredList.includes(propertyConstants.PROPERTY_ID),
            [],
            widthOption?.[propertyConstants.PROPERTY_ID] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_MORE_INFO,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_MORE_INFO),
            tableConstants.TABLE_TYPE_TEXT,
            visibleList.includes(propertyConstants.PROPERTY_MORE_INFO),
            editableList.includes(propertyConstants.PROPERTY_MORE_INFO),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_MORE_INFO),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_MORE_INFO),
            requiredList.includes(propertyConstants.PROPERTY_MORE_INFO),
            [],
            widthOption?.[propertyConstants.PROPERTY_MORE_INFO] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_NAME,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_NAME),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_NAME),
            editableList.includes(propertyConstants.PROPERTY_NAME),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_NAME),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_NAME),
            requiredList.includes(propertyConstants.PROPERTY_NAME),
            [],
            widthOption?.[propertyConstants.PROPERTY_NAME] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_NAME_MASTER,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_NAME_MASTER),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_NAME_MASTER),
            editableList.includes(propertyConstants.PROPERTY_NAME_MASTER),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_NAME_MASTER),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_NAME_MASTER),
            requiredList.includes(propertyConstants.PROPERTY_NAME_MASTER),
            [],
            widthOption?.[propertyConstants.PROPERTY_NAME_MASTER] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_NAME_SYSTEM,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_NAME_SYSTEM),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_NAME_SYSTEM),
            editableList.includes(propertyConstants.PROPERTY_NAME_SYSTEM),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_NAME_SYSTEM),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_NAME_SYSTEM),
            requiredList.includes(propertyConstants.PROPERTY_NAME_SYSTEM),
            [],
            widthOption?.[propertyConstants.PROPERTY_NAME_SYSTEM] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_PRIORITY,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_PRIORITY),
            tableConstants.TABLE_TYPE_NUMBER,
            visibleList.includes(propertyConstants.PROPERTY_PRIORITY),
            editableList.includes(propertyConstants.PROPERTY_PRIORITY),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_PRIORITY),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_PRIORITY),
            requiredList.includes(propertyConstants.PROPERTY_PRIORITY),
            [],
            widthOption?.[propertyConstants.PROPERTY_PRIORITY] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_PRINT_NAME,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_PRINT_NAME),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_PRINT_NAME),
            editableList.includes(propertyConstants.PROPERTY_PRINT_NAME),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_PRINT_NAME),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_PRINT_NAME),
            requiredList.includes(propertyConstants.PROPERTY_PRINT_NAME),
            [],
            widthOption?.[propertyConstants.PROPERTY_PRINT_NAME] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_SEARCH_CODE,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_SEARCH_CODE),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_SEARCH_CODE),
            editableList.includes(propertyConstants.PROPERTY_SEARCH_CODE),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_SEARCH_CODE),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_SEARCH_CODE),
            requiredList.includes(propertyConstants.PROPERTY_SEARCH_CODE),
            [],
            widthOption?.[propertyConstants.PROPERTY_SEARCH_CODE] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_SEARCH_NAME,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_SEARCH_NAME),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_SEARCH_NAME),
            editableList.includes(propertyConstants.PROPERTY_SEARCH_NAME),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_SEARCH_NAME),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_SEARCH_NAME),
            requiredList.includes(propertyConstants.PROPERTY_SEARCH_NAME),
            [],
            widthOption?.[propertyConstants.PROPERTY_SEARCH_NAME] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_TMC_NAME,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_TMC_NAME),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_TMC_NAME),
            editableList.includes(propertyConstants.PROPERTY_TMC_NAME),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_TMC_NAME),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_TMC_NAME),
            requiredList.includes(propertyConstants.PROPERTY_TMC_NAME),
            [],
            widthOption?.[propertyConstants.PROPERTY_TMC_NAME] ?? null
        ),
        new TableHeading(
            propertyConstants.PROPERTY_UUID,
            translationHelper.getPropertyTranslation(objectType, propertyConstants.PROPERTY_UUID),
            tableConstants.TABLE_TYPE_STRING,
            visibleList.includes(propertyConstants.PROPERTY_UUID),
            editableList.includes(propertyConstants.PROPERTY_UUID),
            tableConstants.FILTERABLE_COLUMNS.includes(propertyConstants.PROPERTY_UUID),
            alwaysVisibleList.includes(propertyConstants.PROPERTY_UUID),
            requiredList.includes(propertyConstants.PROPERTY_UUID),
            [],
            widthOption?.[propertyConstants.PROPERTY_UUID] ?? null
        )
    ];

    return tableHelper.sortTableHeadings(list, orderList);
}
